{
  "CUSTOM_ROLE": {
    "HEADER": "Custom Roles",
    "LEARN_MORE": "Learn more about custom roles",
    "DESCRIPTION": "Custom roles are roles that are created by the account owner or admin. These roles can be assigned to agents to define their access and permissions within the account. Custom roles can be created with specific permissions and access levels to suit the requirements of the organization.",
    "HEADER_BTN_TXT": "Add custom role",
    "LOADING": "Fetching custom roles...",
    "SEARCH_404": "There are no items matching this query.",
    "PAYWALL": {
      "TITLE": "Upgrade to create custom roles",
      "AVAILABLE_ON": "The custom role feature is only available in the Business and Enterprise plans.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to advanced features like team management, automations, custom attributes, and more.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "The custom role feature is only available in the paid plans.",
      "UPGRADE_PROMPT": "Upgrade to a paid plan to access advanced features like audit logs, agent capacity, and more.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "LIST": {
      "404": "There are no custom roles available in this account.",
      "TITLE": "Manage custom roles",
      "DESC": "Custom roles are roles that are created by the account owner or admin. These roles can be assigned to agents to define their access and permissions within the account. Custom roles can be created with specific permissions and access levels to suit the requirements of the organization.",
      "TABLE_HEADER": {
        "NAME": "Name",
        "DESCRIPTION": "Description",
        "PERMISSIONS": "Permissions",
        "USAGE_COUNT": "Përdoret nga",
        "ACTIONS": "Actions"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "Manage all conversations",
      "CONVERSATION_UNASSIGNED_MANAGE": "Manage unassigned conversations and those assigned to them",
      "CONVERSATION_PARTICIPATING_MANAGE": "Manage participating conversations and those assigned to them",
      "CONTACT_MANAGE": "Manage contacts",
      "ACCESS_ALL_REPORTS": "Shiko të gjitha raportet",
      "KNOWLEDGE_BASE_MANAGE": "Manage knowledge base",
      "DATA_ASSISTANT_MANAGE": "Menaxho asistentin e të dhënave",
      "CALL_RECORDING_ACCESS": "Qasje në të gjitha regjistrimet e thirrjeve"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Name",
        "PLACEHOLDER": "Please enter a name.",
        "ERROR": "Name is required."
      },
      "DESCRIPTION": {
        "LABEL": "Description",
        "PLACEHOLDER": "Please enter a description.",
        "ERROR": "Description is required."
      },
      "PERMISSIONS": {
        "LABEL": "Permissions",
        "ERROR": "Permissions are required."
      },
      "CANCEL_BUTTON_TEXT": "Cancel",
      "API": {
        "ERROR_MESSAGE": "Could not connect to Woot server. Please try again."
      }
    },
    "ADD": {
      "TITLE": "Add custom role",
      "DESC": " Custom roles allows you to create roles with specific permissions and access levels to suit the requirements of the organization.",
      "SUBMIT": "Submit",
      "API": {
        "SUCCESS_MESSAGE": "Custom role added successfully."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Edit",
      "TITLE": "Edit custom role",
      "DESC": " Custom roles allows you to create roles with specific permissions and access levels to suit the requirements of the organization.",
      "SUBMIT": "Update",
      "API": {
        "SUCCESS_MESSAGE": "Custom role updated successfully."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Delete",
      "API": {
        "SUCCESS_MESSAGE": "Custom role deleted successfully.",
        "ERROR_MESSAGE": "Could not connect to Woot server. Please try again."
      },
      "CONFIRM": {
        "TITLE": "Confirm deletion",
        "MESSAGE": "Are you sure to delete ",
        "YES": "Yes, delete ",
        "NO": "No, keep "
      }
    }
  }
}
